import { BenefitPlan as EmployeeBenefitPlan } from '../employee/benefits/benefit-plan.model';

export class EmployeeBenefitPlans extends EmployeeBenefitPlan {
    protected static _resource = 'benefitManagement/benefitPlans/:benefitPlan/employeeBenefitPlans';

    protected static _version = 'v2';
}
